import React from 'react';

import { markdown } from 'utils/markdownParser';

export const Markdown = React.memo(function Markdown(props: {
  content: string;
}) {
  return <>{markdown(props.content)}</>;
});
